export const STATISTICS_CODES = {
  ST001: 'fromDateFormat',
  ST002: 'invalidHourlyDateFormat',
  ST003: 'invalidDailyDateFormat',
  ST004: 'invalidWeeklyDateFormat',
  ST005: 'invalidMonthlyDateFormat',
};
